import { z } from "zod";

export const phoneNumberValidation = z
  .string()
  .transform((val) => (val.startsWith("0") ? val : "0" + val))
  .refine((val) => val.length === 11, {
    message: "validation.invalid.phoneNumber",
  })
  .refine((val) => /^09\d{9}$/.test(val), {
    message: "validation.default",
  });

const passwordValidation = z
  .string()
  .min(8, "validation.invalid.passwordLength");

export const loginMainSchema = z.object({
  phoneNumber: phoneNumberValidation,
  password: passwordValidation,
});

export const phoneNumberSchema = z.object({
  phoneNumber: phoneNumberValidation,
});

export const verifyOtpSchema = z.object({
  code: z
    .string()
    .length(5, "validation.invalid.otpCodeLength")
    .regex(/^\d{5}$/, "validation.invalid.otpCodeNumeric"),
});

export const createPasswordSchema = z
  .object({
    password: passwordValidation,
    confirmPassword: passwordValidation,
  })
  .refine((data) => data.password === data.confirmPassword, {
    message: "validation.invalid.passwordMismatch",
    path: ["confirmPassword"],
  });
export const changePasswordSchema = z.object({
  // oldPassword: passwordValidation,
  newPassword: passwordValidation,
});
